var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InputText',{attrs:{"id":_vm.name,"label":_vm.label,"data-testid":"cpf-field","name":_vm.name,"mask":_vm.mask,"required":"","value":_vm.value,"status":_vm.status,"helper-text":_vm.error},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }